// @ai-generated 2026-07-28T15:01:24+00:00 by niklas.eicker@tngtech.com using Claude Opus 5
import { EnumPartnershipType } from '@Model';
import { useSession } from '@Contexts/session/SessionContext';

/**
 * Whether the user entered through a portal partnership. Not {@link usePortalEnabled}, which is
 * the operator's mandant-level entitlement and says nothing about the current user's mode.
 */
export function useIsPortalSession(): boolean {
    const {
        current: { partnershipType },
    } = useSession();

    return partnershipType === EnumPartnershipType.Portal;
}
